/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { eventsAPI } from '../services/api';

const card = { background:'#fff', border:'0.5px solid rgba(0,0,0,0.07)', borderRadius:'12px', boxShadow:'0 1px 3px rgba(0,0,0,0.05)' };
const inp = { width:'100%', padding:'7px 11px', background:'#F0EDE5', border:'0.5px solid rgba(0,0,0,0.1)', borderRadius:'7px', fontSize:'12px', color:'#1A1916', outline:'none', fontFamily:'DM Sans, sans-serif' };

export default function OrphanLinkModal({ orphan, onLinked, onIgnored, onClose }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [selected, setSelected] = useState([]);
  const [learnContact, setLearnContact] = useState(true);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (query.length < 2) { setResults([]); return; }
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await eventsAPI.searchDossiers(query);
        setResults(res.data || []);
      } catch { setResults([]); }
      finally { setLoading(false); }
    }, 250);
    return () => clearTimeout(debounceRef.current);
  }, [query]);

  const toggle = (id) => {
    setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const handleLink = async () => {
    if (selected.length === 0) return;
    setSubmitting(true);
    try {
      await eventsAPI.linkOrphan(orphan.id, { dossier_ids: selected, learn_contact: learnContact });
      onLinked?.();
    } catch (e) { console.error(e); }
    finally { setSubmitting(false); }
  };

  const handleIgnore = async () => {
    setSubmitting(true);
    try {
      await eventsAPI.ignoreOrphan(orphan.id);
      onIgnored?.();
    } catch (e) { console.error(e); }
    finally { setSubmitting(false); }
  };

  const p = orphan.payload || {};
  const isZendesk = orphan.source_type === 'zendesk';

  return (
    <div style={{ position:'fixed', inset:0, zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', background:'rgba(0,0,0,0.5)' }} onClick={onClose}>
      <div style={{ ...card, width:'520px', maxHeight:'80vh', overflow:'auto', padding:'1.25rem' }} onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div style={{ fontFamily:'Syne, sans-serif', fontSize:'14px', fontWeight:600, color:'#1A1916', marginBottom:'12px' }}>
          {isZendesk ? 'Ticket Zendesk non lié' : 'Appel Aircall non lié'}
        </div>

        {/* Event details */}
        <div style={{ background:'#F0EDE5', borderRadius:'8px', padding:'10px 14px', marginBottom:'16px', fontSize:'12px', lineHeight:1.7 }}>
          {isZendesk ? (
            <>
              <div><strong>Ticket :</strong> #{p.ticket_id}</div>
              <div><strong>Sujet :</strong> {p.subject || '—'}</div>
              <div><strong>Demandeur :</strong> {p.requester_email || '—'}</div>
              <div><strong>Statut :</strong> {p.status || '—'}</div>
            </>
          ) : (
            <>
              <div><strong>Appel :</strong> {p.direction === 'outbound' ? '↗ Sortant' : '↙ Entrant'}</div>
              <div><strong>Numéro :</strong> {p.number || '—'}</div>
              <div><strong>Durée :</strong> {p.duration ? `${Math.floor(p.duration / 60)}m ${p.duration % 60}s` : '—'}</div>
              {p.contact_email && <div><strong>Email contact :</strong> {p.contact_email}</div>}
            </>
          )}
        </div>

        {/* Search */}
        <div style={{ marginBottom:'12px' }}>
          <div style={{ fontSize:'10px', textTransform:'uppercase', letterSpacing:'0.07em', color:'rgba(26,25,22,0.35)', marginBottom:'5px' }}>Rechercher un dossier</div>
          <input
            style={inp}
            placeholder="Référence, société, SIREN..."
            value={query}
            onChange={e => setQuery(e.target.value)}
            autoFocus
          />
        </div>

        {/* Results */}
        {loading && <div style={{ fontSize:'11px', color:'rgba(26,25,22,0.4)', padding:'8px 0' }}>Recherche...</div>}
        {results.length > 0 && (
          <div style={{ marginBottom:'12px', maxHeight:'200px', overflow:'auto' }}>
            {results.map(d => {
              const isSelected = selected.includes(d.id);
              return (
                <div
                  key={d.id}
                  onClick={() => toggle(d.id)}
                  style={{
                    display:'flex', alignItems:'center', gap:'10px', padding:'8px 10px',
                    borderRadius:'6px', cursor:'pointer', marginBottom:'2px',
                    background: isSelected ? 'rgba(184,134,11,0.08)' : 'transparent',
                    border: isSelected ? '1px solid rgba(184,134,11,0.3)' : '1px solid transparent',
                  }}
                >
                  <div style={{ width:'16px', height:'16px', borderRadius:'3px', border:'1.5px solid', borderColor: isSelected ? '#B8860B' : 'rgba(0,0,0,0.15)', background: isSelected ? '#B8860B' : 'transparent', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    {isSelected && <span style={{ color:'#fff', fontSize:'10px', fontWeight:700 }}>✓</span>}
                  </div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:'12px', fontWeight:500, color:'#1A1916' }}>{d.reference} — {d.societe_nom || '—'}</div>
                    <div style={{ fontSize:'10px', color:'rgba(26,25,22,0.4)' }}>{d.societe_siren || ''} · {d.status}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Selected summary */}
        {selected.length > 0 && (
          <div style={{ fontSize:'11px', color:'#B8860B', fontWeight:500, marginBottom:'8px' }}>
            {selected.length} dossier{selected.length > 1 ? 's' : ''} sélectionné{selected.length > 1 ? 's' : ''}
          </div>
        )}

        {/* Learn contact */}
        <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'16px' }}>
          <input type="checkbox" checked={learnContact} onChange={e => setLearnContact(e.target.checked)} style={{ accentColor:'#B8860B' }} />
          <span style={{ fontSize:'11px', color:'rgba(26,25,22,0.55)' }}>Mémoriser ce contact pour ces dossiers</span>
        </div>

        {/* Actions */}
        <div style={{ display:'flex', gap:'8px', justifyContent:'flex-end' }}>
          <button onClick={onClose} style={{ background:'transparent', border:'0.5px solid rgba(0,0,0,0.12)', borderRadius:'7px', padding:'7px 16px', fontSize:'12px', cursor:'pointer', color:'rgba(26,25,22,0.55)', fontFamily:'DM Sans, sans-serif' }}>
            Annuler
          </button>
          <button onClick={handleIgnore} disabled={submitting} style={{ background:'rgba(176,48,32,0.08)', color:'#B03020', border:'0.5px solid rgba(176,48,32,0.2)', borderRadius:'7px', padding:'7px 16px', fontSize:'12px', cursor:'pointer', fontFamily:'DM Sans, sans-serif' }}>
            Ignorer
          </button>
          <button onClick={handleLink} disabled={selected.length === 0 || submitting} style={{ background:'#B8860B', color:'#fff', border:'none', borderRadius:'7px', padding:'7px 16px', fontSize:'12px', fontWeight:500, cursor: selected.length === 0 ? 'not-allowed' : 'pointer', opacity: selected.length === 0 ? 0.5 : 1, fontFamily:'DM Sans, sans-serif' }}>
            {submitting ? 'Liaison...' : 'Lier'}
          </button>
        </div>
      </div>
    </div>
  );
}
